<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/forum/f-icon1.png"/><span>会议动态</span>
            <router-link class="more right" :to="{name: 'DataListPage', query: {name: '会议动态'}}">更多</router-link>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 noPadding">
            <div class="swiper-container form-swiper" v-if="slideList.length">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(sitem, sidx) in slideList" :key="sidx" @click="newsDetail(sitem.id)">
                  <img v-if="sitem.imgurl" :src="globalVar.imgUrl+sitem.imgurl" alt="">
                  <img v-else src="../../static/images/news/slide.png" alt="">
                  <div class="newss-title">
                    <h4>{{sitem.title}}</h4>
                    <p><v-clamp autoresize :max-lines="1">{{sitem.content.trim()}}</v-clamp></p>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination newsPagination"></div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 noPadding" style="margin-top: 3%;">
            <div class="page-news-list" v-for="(nitem, nidx) in newsList" :key="nidx" @click="newsDetail(nitem.id)">
              <h3><v-clamp autoresize :max-lines="1">{{nitem.title}}</v-clamp></h3>
              <p><v-clamp autoresize :max-lines="2">{{nitem.content}}</v-clamp></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row four-enterWrap">
      <div class="container page-three-enter">
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfFPage', query: {name: '会议室情况'}}"><img src="../../static/images/forum/enter1.png"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'hisFPage', query: {name: '论坛研讨会服务指南'}}"><img src="../../static/images/forum/enter2.png"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'lectureFPage', query: {name: '历届论坛研讨会讲稿汇编'}}"><img src="../../static/images/forum/enter3.png"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter page-m"><router-link :to="{ name: 'meetingPage', query: { name: '会议安排' }}"><img src="../../static/images/forum/enter4.png"/></router-link></div>
      </div>
  </div>
  <div class="row meetingWrap">
    <div class="container">
      <div class="col-xs-12">
        <div class="page-header-news clearfix">
          <img class="icon1" src="../../static/images/forum/f-icon3.png"/><span>会议安排</span>
        </div>
        <div class="page-meeting">
          <div class="page-tab-wrap">
            <div class="page-tab">
              <span :class="{'active' : tabIndex === tIdx}" v-for="(tItem,tIdx) in tabList" :key="tIdx" @click="tabIndex = tIdx">{{tItem}}</span>
            </div>
          </div>
          <div class="row page-table" v-if="tabIndex===0">
            <div class="tableWrap">
              <div class="trRow thRow">
                <div class="td td1">会议名称</div>
                <div class="td td2">日期</div>
                <div class="td td3">时间</div>
                <div class="td td4">地点</div>
                <div class="td td5">报名</div>
              </div>
            </div>
            <div class="tableWrap" v-for="(item, idx) in mlist7" :key="idx">
              <div class="td td-h" v-if="item.type">{{item.type}}</div>
              <div class="trRow" v-for="(citem,cidx) in item.meetlist" :key="cidx">
                <div class="td td1"><a :href="globalVar.pdfUrl+'/#/ForumMeetDet?name=会议安排&id='+citem.meetingID" class="td-a" target="_blank">{{citem.meetingName ? citem.meetingName : citem.meetingEName}}</a></div>
                <div class="td td2">{{citem.meetingDate}}</div>
                <div class="td td3">{{citem.startTime}} - {{citem.endTime}}</div>
                <div class="td td4">{{citem.placeName}}</div>
                <div class="td td5"><a :href="globalVar.SelfServicelogin" class="td-a" v-if="citem.allowReg === '1'" target="_blank">报名</a></div>
              </div>
            </div>
          </div>
          <div class="row page-table" v-if="tabIndex===1">
            <div class="tableWrap">
              <div class="trRow thRow">
                <div class="td td1">会议名称</div>
                <div class="td td2">日期</div>
                <div class="td td3">时间</div>
                <div class="td td4">地点</div>
                <div class="td td5">报名</div>
              </div>
            </div>
            <div class="tableWrap" v-for="(item, idx) in mlist8" :key="idx">
              <div class="td td-h" v-if="item.type">{{item.type}}</div>
              <div class="trRow" v-for="(citem,cidx) in item.meetlist" :key="cidx">
                <div class="td td1"><a :href="globalVar.pdfUrl+'/#/ForumMeetDet?name=会议安排&id='+citem.meetingID" class="td-a" target="_blank">{{citem.meetingName ? citem.meetingName : citem.meetingEName}}</a></div>
                <div class="td td2">{{citem.meetingDate}}</div>
                <div class="td td3">{{citem.startTime}} - {{citem.endTime}}</div>
                <div class="td td4">{{citem.placeName}}</div>
                <div class="td td5"><a :href="globalVar.SelfServicelogin" class="td-a" v-if="citem.allowReg === '1'" target="_blank">报名</a></div>
              </div>
            </div>
          </div>
          <div class="row page-table" v-if="tabIndex===2">
            <div class="tableWrap">
              <div class="trRow thRow">
                <div class="td td1">会议名称</div>
                <div class="td td2">日期</div>
                <div class="td td3">时间</div>
                <div class="td td4">地点</div>
                <div class="td td5">报名</div>
              </div>
            </div>
            <div class="tableWrap" v-for="(item, idx) in mlist9" :key="idx">
              <div class="td td-h" v-if="item.type">{{item.type}}</div>
              <div class="trRow" v-for="(citem,cidx) in item.meetlist" :key="cidx">
                <div class="td td1"><a :href="globalVar.pdfUrl+'/#/ForumMeetDet?name=会议安排&id='+citem.meetingID" class="td-a" target="_blank">{{citem.meetingName ? citem.meetingName : citem.meetingEName}}</a></div>
                <div class="td td2">{{citem.meetingDate}}</div>
                <div class="td td3">{{citem.startTime}} - {{citem.endTime}}</div>
                <div class="td td4">{{citem.placeName}}</div>
                <div class="td td5"><a :href="globalVar.SelfServicelogin" class="td-a" v-if="citem.allowReg === '1'" target="_blank">报名</a></div>
              </div>
            </div>
          </div>
          <div class="row page-table" v-if="tabIndex===3">
            <div class="tableWrap">
              <div class="trRow thRow">
                <div class="td td1">会议名称</div>
                <div class="td td2">日期</div>
                <div class="td td3">时间</div>
                <div class="td td4">地点</div>
                <div class="td td5">报名</div>
              </div>
            </div>
            <div class="tableWrap" v-for="(item, idx) in mlist10" :key="idx">
              <div class="td td-h" v-if="item.type">{{item.type}}</div>
              <div class="trRow" v-for="(citem,cidx) in item.meetlist" :key="cidx">
                <div class="td td1"><a :href="globalVar.pdfUrl+'/#/ForumMeetDet?name=会议安排&id='+citem.meetingID" class="td-a" target="_blank">{{citem.meetingName ? citem.meetingName : citem.meetingEName}}</a></div>
                <div class="td td2">{{citem.meetingDate}}</div>
                <div class="td td3">{{citem.startTime}} - {{citem.endTime}}</div>
                <div class="td td4">{{citem.placeName}}</div>
                <div class="td td5"><a :href="globalVar.SelfServicelogin" class="td-a" v-if="citem.allowReg === '1'" target="_blank">报名</a></div>
              </div>
            </div>
          </div>
          <div class="row page-table" v-if="tabIndex===4">
            <div class="tableWrap">
              <div class="trRow thRow">
                <div class="td td1">会议名称</div>
                <div class="td td2">日期</div>
                <div class="td td3">时间</div>
                <div class="td td4">地点</div>
                <div class="td td5">报名</div>
              </div>
            </div>
            <div class="tableWrap" v-for="(item, idx) in mlist11" :key="idx">
              <div class="td td-h" v-if="item.type">{{item.type}}</div>
              <div class="trRow" v-for="(citem,cidx) in item.meetlist" :key="cidx">
                <div class="td td1"><a :href="globalVar.pdfUrl+'/#/ForumMeetDet?name=会议安排&id='+citem.meetingID" class="td-a" target="_blank">{{citem.meetingName ? citem.meetingName : citem.meetingEName}}</a></div>
                <div class="td td2">{{citem.meetingDate}}</div>
                <div class="td td3">{{citem.startTime}} - {{citem.endTime}}</div>
                <div class="td td4">{{citem.placeName}}</div>
                <div class="td td5"><a :href="globalVar.SelfServicelogin" class="td-a" v-if="citem.allowReg === '1'" target="_blank">报名</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>
  <div class="row partnerWrap">
    <div class="container">
      <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="page-header-news clearfix">
          <img class="icon1" src="../../static/images/forum/f-icon4.png"/><span>会议合作机构</span>
        </div>
        <div class="row page-partner-main">
            <div class="col-xs-6 col-sm-3 col-md-3 page-partner-list"><img src="../../static/images/forum/p-img1.png"/></div>
            <div class="col-xs-6 col-sm-3 col-md-3 page-partner-list"><img src="../../static/images/forum/p-img2.png"/></div>
            <div class="col-xs-6 col-sm-3 col-md-3 page-partner-list"><img src="../../static/images/forum/p-img3.png"/></div>
            <div class="col-xs-6 col-sm-3 col-md-3 page-partner-list"><img src="../../static/images/forum/p-img4.png"/></div>
        </div>
      </div>
    </div>
</div>
</div>
</template>

<script>
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import VClamp from 'vue-clamp'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
  components: {
    subMenuBar,
    VClamp,
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.forum,
      tabList: ["9-6","9-7","9-8","9-9","9-10"],
      tabIndex: 0,
      mlist7: Array,
      mlist8: Array,
      mlist9: Array,
      mlist10: Array,
      mlist11: Array,
      slideList: Array,
      newsList: Array,
    }
  },
  async created(){
    await this.init();
  },
  async activated(){
    await this.findimgnews();
  },
  methods: {
    subpagemenu(item){
      if(item.subName === "国际投资论坛"){
        window.location.href = this.globalVar.iiforum;
      }else{
        this.$router.push({
          name: item.pathName,
          query: {
            name: item.subName,
          }
        })
      }
    },
    async init(){
      // await this.findimgnews();
      // this.swiperInte();
      this.newsList = await this.getData();
      this.mlist7 = await this.meetlistasmx(this.tabList[0]);
      this.mlist8 = await this.meetlistasmx(this.tabList[1]);
      this.mlist9 = await this.meetlistasmx(this.tabList[2]);
      this.mlist10 = await this.meetlistasmx(this.tabList[3]);
      this.mlist11 = await this.meetlistasmx(this.tabList[4]);
    },
    meetlistasmx(date){
      let params = {
        date: date,
        language: this.globalVar.lang
      }
      return this.$store.dispatch("meetlistasmx", params);
    },
    detailHanlde(id){
      this.$router.push({
        name: 'meetDetFPage',
        query: {
          name: '会议安排',
          id: id,
        }
      })
    },
    async findimgnews(){
      let params = {
        count: 5,
        position: 4,//4：论坛研讨会会议动态轮播图
        language: this.globalVar.lang,
      }
      this.slideList = [];
      this.slideList = await this.$store.dispatch("find", params);
      this.swiperInte();
    },
    async getData(){
      let params = {
        count: 3,
        type: 7,//7：会议动态
        language: this.globalVar.lang,
      }
      return await this.$store.dispatch("find", params);
    },
    swiperInte(){
      this.$nextTick(function () {
        var formSwiper = new Swiper ('.form-swiper', {
            autoplay : 3000,
            speed:2000,
            grabCursor : true,
            observer:true,
            observeParents:true,
            loop : true,
            autoplayDisableOnInteraction : false,
            pagination : '.swiper-pagination',
        })
        if(formSwiper.slides.length<=3){
            formSwiper.lockSwipes();
        }
      })
    },
    newsDetail(id){
      this.$router.push({
        name: 'DataListDetPage',
        query: {
          name: '会议动态',
          id: id
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import '../../static/function.less';
.latesWrap{
  margin-top: 1%;
  .noPadding{
    padding: 15px;
  }
  .swiper-slide{
    text-align: center;
    .newss-title{
      position: absolute;
      bottom: 0px;
      background: rgba(0, 0, 0, 0.7);
      left: 0;
      right: 0;
      padding: 2% 3% 0% 2%;
      color: #fff;
      text-align: left;
      h4{
        line-height: 24px;
        font-size: @font16;
      }
      p{
        font-size: @font14;
        margin: 1% 0px 3% 0px;
      }
    }
  }
  .newsPagination{
    bottom: 0px;
  }
  .page-news-list{
    padding-top: 3%;
    padding-left: 8%;
    margin-bottom: 5%;
    background: url("../../static/images/news/icon-bg.png") top left no-repeat;
    background-size: 7%;
    cursor: pointer;
    &:hover{
      h3{
        .hoverTxtColor();
      }
    }
    h3{
      font-size: 18px;
      font-weight: bold;
      color: #303133;
    }
    p{
      font-size: @font14;
      line-height: 20px;
      color: @color767676;
      margin-top: 8px;
      height: 44px;
    }
  }
  .page-other-list{
    margin-top: 2%;
  }
  .page-list{
    margin-top: 3%;
    cursor: pointer;
    p{
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover{
        .hoverTxtColor()
      }
      &:before{
        content:''; 
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }
  .page-other-news{
    padding: 0px 15px;
    margin-bottom: 1%;
    cursor: pointer;
    &:hover{
      p{
        .hoverTxtColor();
      }
    }
    &:before{
      content:''; 
      display: inline-block;
      width: 3px;
      height: 3px;
      background-color: #f00;
      vertical-align: top;
      margin-top: 8px;
      margin-right: 6px;
      border-radius: 50%;
    }
    p{
      font-size: @font14;
      width: 78%;
      display: inline-block;
      color: #303133;
      margin-right: 1%;
    }
    span{
      vertical-align: top;
      margin-top: 2px;
      display: inline-block;
      color: @color767676;
    }
    em{
      color: @color767676;
      float: right;
      margin-top: 2px;
    }
  }
  .page-pic-list{
    padding: 15px 15px 0px 15px;
    cursor: pointer;
    &:hover{
      .hoverTxtColor();
    }
    p{
      font-size: @font14;
      padding: 8px;
      line-height: 20px;
      height: 50px;
    }
  }
}
.four-enterWrap{
  width: 100%;
  margin: 2% 0px;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url('../../static/images/index/adBg.png') no-repeat center;
  background-size: cover;
  .page-three-enter{
    width: 1000px;
  }
  .page-four-enter{
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a{
      display: inline-block;
    }
    &:hover{
      img{
          .shadow(4px)
      }
    }
  }
  .page-m{
    display: none;
  }
}
.meetingWrap{
  .page-meeting{
    padding: 15px 0px;
    .tableWrap{
      
      font-size: 16px;
      .trRow{
        .flexcontentitems(space-between, center);
        border-bottom: 1px solid #efefef;
      }
      .td{padding: 10px;}
      .td1{width: 40%}
      .td2{width: 5%}
      .td3{width: 15%}
      .td4{width: 35%}
      .td5{width: 5%}
      .td-h{
        font-weight: bold;
        border-bottom: 1px solid #efefef;
      }
      .td-a{
        &:hover{
          .hoverTxtColor();
        }
      }
    }
  }
}
.page-tab-wrap .page-tab{
  width: 50%;
}
.partnerWrap{
    margin: 2% auto;
    text-align: center;
    .page-header-news{
        border-bottom: none;
    }
    .page-partner-main{
        .page-partner-list{
            margin: 20px 0px;
        }
    }
}
.page-tab-wrap .page-tab span{
  font-size: 20px;
}
@media (min-width: 320px) and (max-width: 767px){
  .slideMenu,.four-enterWrap .page-m{
    display: block;
  }
  .meetingWrap{
    .page-meeting{
      padding: 15px 0px;
      
    }
  }
  .page-tab-wrap{
    .page-tab{
      width: 100%;
      span{
        // display: inline-block;
        // -webkit-box-flex: unset;
        // -moz-box-flex: unset;
        // -webkit-flex: unset;
        // -ms-flex: unset;
        // flex: unset;
      }
    }
  }
  .four-enterWrap .page-three-enter{
    width: 100%;
  }
  .meetingWrap{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Forum.vue